export default __webpack_public_path__ + "static/media/rps1.96118fc2.jpeg";